import deepmerge from 'deepmerge';
import { useSelector } from 'react-redux';
import { DEFAULT_MARKET } from '@clearscore/config.i18n';
import { selectors as marketSelectors } from '@clearscore/redux.market';

const isObject = (value) => value && typeof value === 'object' && value.constructor === Object;

const useMarketConfig = (marketConfig) => {
    if (!marketConfig || !isObject(marketConfig)) throw new Error('A market config object must be provided');

    const geoMarket = useSelector(marketSelectors.getGeoMarket);
    const activeMarket = useSelector(marketSelectors.getActiveMarket);
    const market = geoMarket || activeMarket;

    // DEFAULT_MARKET is deprecated and will be removed.
    // Common config should be placed under a 'common' property.
    const baseConfig = marketConfig.common || marketConfig[DEFAULT_MARKET];

    if (marketConfig[market]) {
        return baseConfig
            ? deepmerge(baseConfig, marketConfig[market], {
                  arrayMerge: (_, sourceArray) => sourceArray,
              })
            : marketConfig[market];
    }

    return baseConfig || null;
};

export default useMarketConfig;
